/*
 * Public API Surface of dreamparse
 */

export * from './lib/dreamparse.service';
export * from './lib/dreamparse.module';
